// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";

const AdminGetWebPageApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/get_web_page";

    // API実行
    const ExecAdminGetWebPageApi = async (requestParams) => {
        // 必要なリクエストを定義

        let response = null;
        let error = null;

        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url, requestParams, auth:true});
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminGetWebPageApi;
};

export default AdminGetWebPageApi;